// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"footer-module__footerWrapper___Jrx-U","customFooterText":"footer-module__customFooterText___b76Fi","copyrightText":"footer-module__copyrightText___GB1NJ"};